import React from 'react';
import { Users, Megaphone, Sliders, Ticket, MessageSquare, X, LogOut, Shield, ExternalLink, MessageCircle } from 'lucide-react';

const AdminSidebar = ({
    activeTab,
    setActiveTab,
    sidebarOpen,
    setSidebarOpen,
    handleLogout,
    isMobile,
    userProfile
}) => {
    const userRole = userProfile?.role || 'admin';
    const isFullAdmin = userRole === 'admin';

    const menu = [
        { id: 'users', label: 'Gestão de Usuários', icon: <Users size={19} /> },
        { id: 'broadcast', label: 'Disparador WhatsApp', icon: <Megaphone size={19} /> },
        { id: 'whatsapp_instances', label: 'Instâncias WhatsApp', icon: <MessageCircle size={19} /> },
        ...(isFullAdmin ? [
            { id: 'rules', label: 'Regras & Limites', icon: <Sliders size={19} /> },
            { id: 'coupons', label: 'Cupons de Desconto', icon: <Ticket size={19} /> }
        ] : []),
        { id: 'chat', label: 'Atendimento / Chat', icon: <MessageSquare size={19} /> }
    ];

    const getRoleBadge = (role) => {
        switch (role) {
            case 'admin':
                return { label: 'Administrador', bg: '#9333ea', text: '#ffffff' };
            case 'moderator':
                return { label: 'Moderador', bg: '#f59e0b', text: '#ffffff' };
            case 'support':
                return { label: 'Suporte', bg: '#3b82f6', text: '#ffffff' };
            default:
                return { label: 'Equipe', bg: '#64748b', text: '#ffffff' };
        }
    };

    const roleBadge = getRoleBadge(userRole);

    const handleMenuClick = (id) => {
        setActiveTab(id);
        if (isMobile) {
            setSidebarOpen(false);
        }
    };

    return (
        <div style={{
            width: '260px',
            backgroundColor: '#090d16',
            borderRight: '1px solid #1e293b',
            color: 'white',
            display: 'flex',
            flexDirection: 'column',
            position: 'fixed',
            height: '100vh',
            left: sidebarOpen ? '0' : '-260px',
            transition: 'left 0.3s ease',
            zIndex: 1000,
            boxSizing: 'border-box',
            fontFamily: 'Outfit, sans-serif'
        }}>
            {/* Header / Brand */}
            <div style={{
                padding: '24px 20px',
                borderBottom: '1px solid #1e293b',
                position: 'relative',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between'
            }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    <div style={{
                        width: '42px',
                        height: '42px',
                        borderRadius: '12px',
                        backgroundColor: 'rgba(147, 51, 234, 0.15)',
                        border: '1px solid rgba(147, 51, 234, 0.3)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}>
                        <Shield size={22} color="#c084fc" />
                    </div>
                    <div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                            <span style={{ color: '#fff', fontSize: '15px', fontWeight: '800', letterSpacing: '-0.02em' }}>
                                Anúncios App
                            </span>
                            <span style={{
                                backgroundColor: '#9333ea',
                                color: '#fff',
                                fontSize: '10px',
                                fontWeight: '800',
                                padding: '1px 6px',
                                borderRadius: '4px',
                                textTransform: 'uppercase'
                            }}>
                                Gestão
                            </span>
                        </div>
                        <span style={{ color: '#64748b', fontSize: '11px', fontWeight: '500' }}>
                            Painel Administrativo
                        </span>
                    </div>
                </div>

                {isMobile && (
                    <button
                        onClick={() => setSidebarOpen(false)}
                        style={{
                            background: 'none',
                            border: 'none',
                            color: '#94a3b8',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            padding: '4px'
                        }}
                    >
                        <X size={20} />
                    </button>
                )}
            </div>

            {/* Navigation Menus */}
            <div style={{ flex: 1, padding: '20px 14px', display: 'flex', flexDirection: 'column', gap: '6px', overflowY: 'auto' }}>
                <div style={{
                    color: '#64748b',
                    fontSize: '11px',
                    fontWeight: '700',
                    textTransform: 'uppercase',
                    letterSpacing: '0.08em',
                    padding: '0 10px',
                    marginBottom: '6px'
                }}>
                    Módulos Administrativos
                </div>

                {menu.map((item) => {
                    const isActive = activeTab === item.id;
                    return (
                        <button
                            key={item.id}
                            onClick={() => handleMenuClick(item.id)}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '12px',
                                padding: '12px 14px',
                                borderRadius: '10px',
                                border: 'none',
                                cursor: 'pointer',
                                textAlign: 'left',
                                width: '100%',
                                backgroundColor: isActive ? '#9333ea' : 'transparent',
                                color: isActive ? '#ffffff' : '#94a3b8',
                                fontWeight: isActive ? '700' : '500',
                                fontSize: '14px',
                                transition: 'all 0.15s ease',
                                outline: 'none'
                            }}
                            onMouseEnter={(e) => {
                                if (!isActive) {
                                    e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.05)';
                                    e.currentTarget.style.color = '#f8fafc';
                                }
                            }}
                            onMouseLeave={(e) => {
                                if (!isActive) {
                                    e.currentTarget.style.backgroundColor = 'transparent';
                                    e.currentTarget.style.color = '#94a3b8';
                                }
                            }}
                        >
                            <span style={{ color: isActive ? '#ffffff' : '#a855f7' }}>
                                {item.icon}
                            </span>
                            <span style={{ flex: 1 }}>{item.label}</span>
                        </button>
                    );
                })}
            </div>

            {/* Footer / User Profile & Logout */}
            <div style={{
                padding: '16px 14px',
                borderTop: '1px solid #1e293b',
                backgroundColor: '#0c1322'
            }}>
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                    padding: '8px 10px',
                    borderRadius: '10px',
                    backgroundColor: 'rgba(255, 255, 255, 0.03)',
                    marginBottom: '12px'
                }}>
                    <div style={{
                        width: '36px',
                        height: '36px',
                        borderRadius: '50%',
                        backgroundColor: '#9333ea',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontWeight: '700',
                        fontSize: '14px',
                        color: '#fff',
                        flexShrink: 0
                    }}>
                        {(userProfile?.name || userProfile?.username || 'A')[0].toUpperCase()}
                    </div>
                    <div style={{ flex: 1, minWidth: 0 }}>
                        <div style={{
                            color: '#f8fafc',
                            fontSize: '13px',
                            fontWeight: '600',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis'
                        }}>
                            {userProfile?.name || userProfile?.username || 'Equipe Admin'}
                        </div>
                        <span style={{
                            display: 'inline-block',
                            backgroundColor: roleBadge.bg,
                            color: roleBadge.text,
                            fontSize: '10px',
                            fontWeight: '700',
                            padding: '1px 6px',
                            borderRadius: '4px',
                            marginTop: '2px'
                        }}>
                            {roleBadge.label}
                        </span>
                    </div>
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                    <button
                        onClick={() => window.location.href = '/'}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            width: '100%',
                            padding: '9px 12px',
                            background: 'none',
                            border: 'none',
                            borderRadius: '8px',
                            color: '#94a3b8',
                            fontSize: '12px',
                            cursor: 'pointer',
                            textAlign: 'left',
                            transition: 'background 0.2s, color 0.2s'
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.05)';
                            e.currentTarget.style.color = '#f8fafc';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = 'transparent';
                            e.currentTarget.style.color = '#94a3b8';
                        }}
                    >
                        <ExternalLink size={14} color="#64748b" />
                        <span>Abrir App Afiliados</span>
                    </button>

                    <button
                        onClick={handleLogout}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            width: '100%',
                            padding: '9px 12px',
                            background: 'none',
                            border: 'none',
                            borderRadius: '8px',
                            color: '#ef4444',
                            fontSize: '12px',
                            fontWeight: '600',
                            cursor: 'pointer',
                            textAlign: 'left',
                            transition: 'background 0.2s'
                        }}
                        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'rgba(239, 68, 68, 0.1)'}
                        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                    >
                        <LogOut size={14} color="#ef4444" />
                        <span>Encerrar Sessão</span>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AdminSidebar;
